import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { dirname } from "../../../../util/resourcePath";

const NoUsersComp = (props) => {
	const directory = dirname();
	const [selectedClient, setSelectedClient] = useState(false);
	const userHasEditRole = props.userHasEditRole;
	const clientIsSelected = selectedClient != "ALL" && selectedClient != false;

	const containerStyle = {
		textAlign: "center",
		padding: "10% 0",
	};

	useEffect(() => {
		if (!selectedClient || props.selectedClient !== selectedClient)
			setSelectedClient(props.selectedClient);
	}, [props.selectedClient]);

	return (
		<Row style={containerStyle}>
			<Col md={12}>
				<Row>
					{clientIsSelected && (
						<img
							src={`${directory}/images/add-form2.png`}
							style={{
								height: "22%",
								width: "22%",
								cursor: "pointer",
								opacity: "0.5",
							}}
							alt="logo"
							onClick={() =>
								userHasEditRole
									? props.redirectToForm(selectedClient)
									: alert("You do not have access to add new users")
							}
						/>
					)}
				</Row>
				{clientIsSelected ? <h1>No Users</h1> : <h1>No Sites</h1>}
				{clientIsSelected && <h2>Please add a user</h2>}
			</Col>
		</Row>
	);
};

export default NoUsersComp;
